import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { MegaData } from "./menu-data";

export function MobileSubmenu({
  title,
  data,
  onBack,
  onNavigate,
}: {
  title: string;
  data: MegaData;
  onBack: () => void;
  onNavigate: () => void;
}) {
  return (
    <div className="flex h-full flex-col">
      <div className="sticky top-0 z-10 flex items-center gap-2 border-b bg-white px-4 py-3">
        <button onClick={onBack} className="text-n-text-green">
          <ArrowLeft className="" />
          <span className="sr-only">Voltar</span>
        </button>
        <p className="text-base font-semibold text-n-text">{title}</p>
      </div>
      <div className="flex-1 overflow-y-auto px-4 py-4">
        {data.groups.map((group) => (
          <div key={group.title} className="mb-6">
            <p className="text-sm font-semibold text-n-text">{group.title}</p>
            <ul className="mt-2 space-y-1">
              {group.items.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    onClick={onNavigate}
                    className="block rounded-md px-2 py-2 text-n-text-neutral hover:bg-n-green-h-light hover:text-n-text-green"
                  >
                    <p className="font-medium text-n-text">{item.label}</p>
                    {item.description && (
                      <p className="text-xs text-n-text-neutral">
                        {item.description}
                      </p>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
            <Separator className="mt-4 bg-n-green-1" />
          </div>
        ))}
      </div>
      <div className="p-4">
        <Link to="/fazer-cotacao" onClick={onNavigate}>
          <Button className="w-full bg-n-green-action text-n-text-green hover:bg-n-green-4">
            Fazer Orçamento
          </Button>
        </Link>
      </div>
    </div>
  );
}
